var map = {
	"./images/frank-luca-wUo-wgIHTac-unsplash_cropped.jpg": 368,
	"./images/kursus-aabne-ordrer.jpg": 371,
	"./images/kursus-bilagshaandtering.png": 374,
	"./images/skvizbiz_kursus_fakturaarkivet.jpg": 377,
	"./images/soeg_i_beskeder.png": 380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 367;